'use strict';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var supportsDisabledAttribute = function supportsDisabledAttribute(element) {
  return ['button', 'input', 'select', 'textarea', 'fieldset', 'optgroup', 'option'].includes(element.tagName.toLowerCase());
};

module.exports = supportsDisabledAttribute;
